import DotsLoading from 'components/loadings/dotsLoading'
import { Field, Form, Formik } from 'formik'
import useSetAuthProfile from 'modules/auth/profile/hooks/useSetAuthProfile'
import { makeSchema } from 'modules/auth/profile/utilities'
import { useState } from 'react'
import ProfileModal from 'components/modals/authProfile'
import ProfileIcon from 'assets/images/account/profile.svg'
import CustomButton from 'components/customButtons/primary'
import GenderModal from './modal'
import BackIcon from 'assets/images/rectangle/right-green.svg'
import { useNavigate } from 'react-router-dom'
export default function Profile() {
    const [showModal, setShowModal] = useState<boolean>(false)
    const [showGenderModal, setShowGenderModal] = useState<boolean>(false)
    const [gender, setGender] = useState<string>('')
    const { mutate } = useSetAuthProfile(setShowModal)
    const navigate = useNavigate()
    const stringifyProfile = localStorage.getItem('profile')
    const profile: IAuthProfileData | undefined =
        stringifyProfile && JSON.parse(stringifyProfile)
    return (
        <div className=" w-full ">
            {!profile ? (
                <div className=" w-full h-screen items-center">
                    <DotsLoading />
                </div>
            ) : (
                <Formik
                    enableReinitialize
                    initialValues={{
                        first_name:
                            profile.first_name.length > 0
                                ? profile.first_name
                                : '',
                        last_name:
                            profile.last_name.length > 0
                                ? profile.last_name
                                : '',
                        email: profile.email.length > 0 ? profile.email : '',
                        gender: profile.gender.length > 0 ? profile.gender : '',
                    }}
                    validationSchema={makeSchema({
                        first: !(profile.first_name.length > 0),
                        last: !(profile.last_name.length > 0),
                    })}
                    onSubmit={async (values) => {
                        const payload: IAuthprofilePayload = {
                            ...(profile &&
                                profile.first_name !== values.first_name && {
                                    first_name: values.first_name,
                                }),
                            ...(profile &&
                                values.last_name !== profile?.last_name && {
                                    last_name: values.last_name,
                                }),
                            ...(profile &&
                                profile.email !== values.email && {
                                    email: values.email,
                                }),
                            ...(profile &&
                                profile.gender !== gender && {
                                    gender: gender,
                                }),
                        }
                        mutate(payload)
                    }}
                >
                    {({ values, touched, errors }) => (
                        <Form
                            className="h-screen flex flex-col"
                            id="authProfile"
                        >
                            {/* items-center, and a sized icon, both matter: the
                                row is as tall as the title's `my-6`, and a
                                flex item that stretches scales an <img> with
                                it — which is how an 18px arrow rendered at
                                ~80px here and nowhere else. The trailing
                                span balances the icon so the title is
                                actually centred. */}
                            <div className=" flex items-center justify-between mx-4">
                                <img
                                    src={BackIcon}
                                    alt="بازگشت"
                                    onClick={() => navigate(-1)}
                                    className=" w-6 h-6 cursor-pointer active:scale-90"
                                />
                                <p className=" text-center text-green-1 my-6 ">
                                    ویرایش اطلاعات
                                </p>
                                <span className="w-6" />
                            </div>
                            <div className=" mx-4  mt-24 text-center grow">
                                <div className=" bg-white shadow-md rounded-md">
                                    <img
                                        src={ProfileIcon}
                                        className=" mx-auto -mt-10 "
                                        alt="profile-icon"
                                    />
                                    <p className=" text-gray-1 my-4">
                                        تلفن همراه
                                    </p>
                                    <p className=" mb-4 text-sm">
                                        0{profile?.phone_number.slice(3)}
                                    </p>
                                    <div>
                                        {profile?.first_name.length > 0 ? (
                                            <p className=" w-full outline-0 text-center border-t border-b border-dashed border-gray-1 py-3">
                                                {profile.first_name}
                                            </p>
                                        ) : (
                                            <Field
                                                type="text"
                                                className=" w-full outline-0 text-center border-t border-b border-dashed border-gray-1 py-3"
                                                placeholder="نام (الزامی)"
                                                name="first_name"
                                            />
                                        )}
                                        {touched.first_name &&
                                            errors.first_name && (
                                                <p className=" text-xs text-red-1">
                                                    {errors.first_name}
                                                </p>
                                            )}
                                        {profile?.last_name.length > 0 ? (
                                            <p className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3">
                                                {profile.last_name}
                                            </p>
                                        ) : (
                                            <Field
                                                type="text"
                                                className=" w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                                placeholder="نام خانوادگی (الزامی)"
                                                name="last_name"
                                            />
                                        )}
                                        {touched.last_name &&
                                            errors.last_name && (
                                                <p className=" text-xs text-red-1">
                                                    {errors.last_name}
                                                </p>
                                            )}
                                        {profile &&
                                        profile?.email.length > 0 ? (
                                            <p className="w-full outline-0 text-center border-b border-dashed border-gray-1 py-3">
                                                {profile.email}
                                            </p>
                                        ) : (
                                            <>
                                                <Field
                                                    type="text"
                                                    className=" w-full outline-0 text-center border-b border-dashed border-gray-1 py-3"
                                                    placeholder="پست الکترونیک (اختیاری)"
                                                    name="email"
                                                />
                                                {touched.email &&
                                                    errors.email && (
                                                        <p className=" text-xs text-red-1">
                                                            {errors.email}
                                                        </p>
                                                    )}
                                            </>
                                        )}

                                        <p className="w-full outline-0 text-center py-3">
                                            کد معرف(اختیاری)
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className=" mb-4 mx-6">
                                <CustomButton
                                    label="تایید"
                                    type="button"
                                    setShowModal={() => setShowModal(true)}
                                />
                            </div>
                            <ProfileModal
                                show={showModal}
                                onHide={() => setShowModal(false)}
                                type="submit"
                            />
                            <GenderModal
                                show={showGenderModal}
                                onHide={() => setShowGenderModal(false)}
                                setGender={setGender}
                            />
                        </Form>
                    )}
                </Formik>
            )}
        </div>
    )
}
